package com.mshopsas.enterprise.aiw.scan.network.response

import kotlinx.serialization.Serializable

@Serializable
data class ConfirmPaymentResponse(
    val result: String
)